import { useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { AppRoute, ButtonType } from '../../types/enums';
import { Dashboard } from '../../types/types';
import { getDashboardUrlById } from '../../utils/common';
import Button from '../Button/Button';

import styles from './DashboardCreated.module.scss';

const DashboardCreated = () => {
  const navigate = useNavigate();
  const { state }: { state: Dashboard | null } = useLocation();

  useEffect(() => {
    if (!state?.id) {
      navigate(AppRoute.DASHBOARDS);
    }
  }, []);

  return (
    <div>
      <h3 className={styles.title}>{state?.name}</h3>
      <p>
        <strong>Page URL:</strong>{' '}
        <a
          className={styles.link}
          href={getDashboardUrlById(state?.id ?? '')}
          target="_blank"
          rel="noreferrer">
          {getDashboardUrlById(state?.id ?? '')}
        </a>
      </p>
      {state?.websites?.length ? (
        <>
          <strong>Websites:</strong>
          <ul>
            {state.websites.map(({ name, url }) => (
              <li key={url}>
                <a target="_blank" rel="noreferrer" href={url}>
                  {name}
                </a>
              </li>
            ))}
          </ul>
        </>
      ) : null}
      <div className="flex">
        <NavLink to={AppRoute.DASHBOARD_NEW}>
          <Button type={ButtonType.PRIMARY}>Add new dashboard</Button>
        </NavLink>
        <NavLink className={styles.link} to={AppRoute.DASHBOARDS}>
          GO TO DASHBOARD LIST
        </NavLink>
      </div>
    </div>
  );
};

export default DashboardCreated;
